import { Link, useLocation } from "react-router-dom";
import "./AdminNavigationLinks.css";

const AdminNavigationLinks = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="adminNavLinks">
      <Link
        to="/admin"
        className={`adminNavLink ${isActive("/admin") ? "active" : ""}`}
      >
        Admin panel
      </Link>

      <Link
        to="/locations"
        className={`adminNavLink ${isActive("/locations") ? "active" : ""}`}
      >
        Lokacije
      </Link>

      <Link
        to="/predefined-routes"
        className={`adminNavLink ${
          isActive("/predefined-routes") ? "active" : ""
        }`}
      >
        Rute
      </Link>
    </div>
  );
};

export default AdminNavigationLinks;
